import { Component, OnInit, OnDestroy, ViewChild, ViewEncapsulation, AfterViewInit, ChangeDetectorRef, AfterContentChecked } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { StorageManagerService, DeviceinventoryService } from '../../shared/services/index';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { fadeInOut } from '../../shared/helpers/animations';
import { ICustomer, IRevisionHistory, IServiceError } from '../../shared/models/index';
import { DialogComponent } from '@syncfusion/ej2-angular-popups';
import { EmitType } from '@syncfusion/ej2-base';
import { AccordionComponent } from '@syncfusion/ej2-angular-navigations';
import { FormGroup, FormBuilder } from '@angular/forms';
import { AccordionItem } from '@syncfusion/ej2-navigations';
import { FeatureService } from '../../shared/services/feature.service';

@Component({
	selector: 'app-item-details',
	templateUrl: './item-details.component.html',
	styleUrls: ['./item-details.component.scss'],
	animations: [fadeInOut],
	encapsulation: ViewEncapsulation.Emulated
})
export class ItemDetailsComponent implements OnInit, OnDestroy, AfterViewInit, AfterContentChecked {


	userGuid: string;
	customer: ICustomer;
	itemUdi: string;
	itemIssuingAgency: string;
	revisions: IRevisionHistory[] = [];
	revisionNumber: number;
	subscription: Subscription;
	visible = false;
	resolverData: any[] | IServiceError;

	target = '#modalTarget';
	position: object = { X: 'center', Y: 'center' };
	modalWidth = '30%';
	modalHeight = 'auto';
	animationSettings: Object = { effect: 'Zoom' };
	isModal = true;
	deviceMapping: any;
	mapArray = [];
	itemData: any;
	documentId: string;
	dataScope: string;
	defaultPropsArray: string[] = [];
	readOnly = true;
	udiDI: string;
	budi: string;
	agency: string;
	productSKU: string;
	itemType: string;
	modelBUDI: string;
	modelAgency: string;
  headerVar: string;
  showLegacy: boolean;

	deviceForm: FormGroup;

	accordionItemsData: any = [];
	public mapping = { header: 'header', content: 'content' };

	@ViewChild('dialog', { static: true })
	public dialog: DialogComponent;

	@ViewChild('properties') accordionObj: AccordionComponent;

  itemTemplate: string;

  eudamedId: string;
  eudamedIdIssuingAgency: string;
  eudamedDi: string;
  eudamedDiIssuingAgency: string;

	public btnClick: EmitType<object> = () => {
		this.dialog.show();
	}

  constructor(private activatedRoute: ActivatedRoute, private storage: StorageManagerService, private router: Router, private deviceInventoryService: DeviceinventoryService, private authenticationService: AuthenticationService, private cdref: ChangeDetectorRef, private fb: FormBuilder,
    protected featureService: FeatureService) { }

  ngOnInit() {

    //Defaulting legacyData to false
    this.showLegacy = false;

    // Get user and customer
    this.getPrincipals();
    this.getResolverData();

    this.udiDI = this.displayItemData('Primary DI');
    this.revisionNumber = +this.displayItemData('Revision Number');
    this.budi = this.displayItemData('Basic UDI-DI');
    this.agency = this.displayItemData('Primary DI Issuing Agency');
    this.productSKU = this.displayItemData('Product SKU');
    this.modelBUDI = this.displayItemData('BUDI-DI');
    this.modelAgency = this.displayItemData('BUDI-DI Issuing Agency');
    this.eudamedId = this.displayItemData('Eudamed ID');
    this.eudamedIdIssuingAgency = this.displayItemData('Eudamed ID Issuing Agency');
    this.eudamedDi = this.displayItemData('Eudamed DI');
    this.eudamedDiIssuingAgency = this.displayItemData('Eudamed DI Issuing Agency');

    // set focus on the invisible div so the firest tab will bring it to the "Skip to Main Navigation" button because it must be the first tab target on the page (508 Compliance)
    this.initTabIndex();
  }

  initTabIndex() {
    (document.activeElement as HTMLElement).blur();

    const main = document.getElementById('firstDiv');

    if (main) {
      main.focus();
    }
  }

	ngAfterContentChecked() {

		this.cdref.detectChanges();
	}

	private getResolverData() {

		let revisionData;

		if (this.activatedRoute.snapshot.data && this.activatedRoute.snapshot.data.itemData.length) {

			// Device mapping
			if (this.activatedRoute.snapshot.data.itemData[1] && this.activatedRoute.snapshot.data.itemData[1] !== 'error') {
				this.deviceMapping = this.activatedRoute.snapshot.data.itemData[1];

				Object.keys(this.deviceMapping).map(e => {

					this.mapArray.push({ key: e, value: this.deviceMapping[e] });
				});
			}

			if (this.activatedRoute.snapshot.data.itemData[2] !== 'error') {

				this.itemData = this.activatedRoute.snapshot.data.itemData[2].data;
				this.itemType = this.itemData.documentType;
        this.headerVar = this.itemType === 'model' ? 'Model' : 'Device';

        // If legacy data is present then change the header
        if (this.dataScope.toLowerCase() === 'eudamed') {
          // Now see if the feature 'eu-legacy-data-import' is enabled
          this.featureService.IsFeatureEnabled('eu-legacy-data-import').subscribe(response => {
            if (response) {
              if (this.itemData.hasOwnProperty('eudamedID') || this.itemData.hasOwnProperty('eudamedDI')) {
                this.headerVar = this.itemType === 'model' ? 'Legacy Model' : 'Legacy Device';
                this.showLegacy = true;
              }
            }
          });
        }
			}

			if (this.activatedRoute.snapshot.data.itemData[0] !== 'error') {

				revisionData = this.activatedRoute.snapshot.data.itemData[0].data;

				if (revisionData && this.activatedRoute.snapshot.data.itemData[0].isSuccess) {

					this.revisions = revisionData;
					this.revisionNumber = this.revisions[0].revision;
				}
			}

			if (!this.itemData || !revisionData) {

				this.retrieveOnPageReload();
			}
		}
	}

	displayItemData(field: string): string {

		let retVal: any;
		let prop: any;
		let propValue: string;
		let itemValuePath = [];
		let itemPropsPathSegment: any;
    let defaultPropsPathSegment: any;

    this.itemType = this.itemData.documentType;

		if (this.itemData && field) {

			prop = this.mapArray.find(p => p.key.toLowerCase() === field.toLowerCase());

			if (prop) {
				propValue = prop.value;

				if (propValue) {

					// Multi path value
					if (propValue.indexOf('/') > -1) {

						if (propValue.indexOf('<dataScope>') > -1) {

							propValue = propValue.replace('<dataScope>', this.dataScope);
						}

						if (propValue.indexOf('<documentType>') > -1) {

							propValue = propValue.replace('<documentType>', this.itemType + 'Data');
						}

						itemValuePath = propValue.split('/');

						if (itemValuePath && itemValuePath.length > 0) {

							// Top level item data
							itemPropsPathSegment = this.itemData;

							// Get Default settings to be able to use it if there is no data for the dataScope.
							defaultPropsPathSegment = this.itemData;

							itemValuePath.forEach(path => {

								// if dataScope segment or value is undefined check if it exists in Default.
                if (itemPropsPathSegment && Object.keys(itemPropsPathSegment).length) {

									itemPropsPathSegment = itemPropsPathSegment[path];
                  // reached the datascope level - get the default first to be able use it if datascope value is not found.
									if (path.toLowerCase() === this.dataScope.toLowerCase()) {
										path = 'default';
									}

                  // get value from the default
									if (defaultPropsPathSegment) {
										defaultPropsPathSegment = defaultPropsPathSegment[path];
									}

								} else {
									if (defaultPropsPathSegment) {
										if (!Array.isArray(defaultPropsPathSegment)) {
											defaultPropsPathSegment = defaultPropsPathSegment[path];
										}
									}
								}
							});
            }

            // should allow the blank space so testing it against the undefined
            if (itemPropsPathSegment !== undefined && itemPropsPathSegment !== null) {

              if (typeof itemPropsPathSegment === 'object' && !Object.keys(itemPropsPathSegment).length) {
                itemPropsPathSegment = '';
              }

              retVal = itemPropsPathSegment;
            } else {

              retVal = defaultPropsPathSegment;

              if (defaultPropsPathSegment) {
                this.defaultPropsArray.push(field);
              }
            }
					} else {

						// Single path value
						retVal = this.itemData[propValue];
					}
				}
			}
		}

		return retVal;
	}

	isDefault(field: string): string {

		return this.defaultPropsArray.includes(field) ? 'highlight-fill' : '';
	}

	private retrieveOnPageReload() {

		this.activatedRoute.params.subscribe(params => {

			this.documentId = params['id'];
		});

		this.authenticationService.getIsAuthorized().subscribe(auth => {

			if (auth) {

				this.deviceInventoryService.getRevisionHistory(this.documentId, this.customer.customerId).subscribe((response: IRevisionHistory) => {

					if (response && response['isSuccess'] && response['data']) {
						this.revisions = response['data'];
						this.revisionNumber = response['data'][0].revision;
					}
				});

				this.deviceInventoryService.getInventoryItem(this.documentId, this.customer.customerId).subscribe(response => {
					if (response && response['isSuccess'] && response['data']) {
						this.itemData = response['data'];
					}
				});
			}
		});
	}

	private getPrincipals() {

		// Get the userGuid
		this.userGuid = this.storage.read('userGuid');

		if (!this.userGuid) {
			this.router.navigate(['error', 'User is not logged in']);
		}

		// Get the current Customer
		const customer = this.storage.read('currentCustomer');

		if (customer) {

			this.customer = typeof customer === 'object' ? customer : <ICustomer>JSON.parse(customer);
		} else {
			this.router.navigate(['/home']);
		}

		this.dataScope = this.storage.read('dataScope');
	}

	accordionCreated(event) {

		this.accordionObj.items[0].expanded = true;

		this.accordionObj.refresh();
	}

	ngAfterViewInit(): void {

		this.visible = false;
	}

	returnToInventory() {

		this.router.navigate(['managedi/inventory']);
	}

	// Show the Revision History (retrieved above)
	displayRevisionHistory(event) {

		this.visible = true;
		this.dialog.show();
	}

	public onOverlayClick: EmitType<object> = () => {
		this.visible = false;
		this.dialog.hide();
	}

	collapseAll() {

		this.accordionObj.items.forEach((i: AccordionItem) => {

			this.accordionObj.expandItem(false);
		});
	}

	expandAll() {

		this.accordionObj.items.forEach((i: AccordionItem) => {

			this.accordionObj.expandItem(true);
		});
	}

	revisionHistoryClose(event) {
		this.visible = false;
		this.dialog.hide();
	}

	ngOnDestroy(): void {
		if (this.subscription) {
			this.subscription.unsubscribe();
		}
	}
}
